const goalList = [
	{
		goalName: "acquire",
		goalDescription: "Acquire new customers",
		goalIcon: "./images/goals-icon-acquire.svg",
		goalIconFilled: "./images/goals-icon-filled-acquire.svg"
	},
	{
		goalName: "lifetime",
		goalDescription: "Increase customer lifetime value",
		goalIcon: "./images/goals-icon-lifetime.svg",
		goalIconFilled: "./images/goals-icon-filled-lifetime.svg"
	},
	{
		goalName: "advocacy",
		goalDescription: "Encourage customer advocacy",
		goalIcon: "./images/goals-icon-advocacy.svg",
		goalIconFilled: "./images/goals-icon-filled-advocacy.svg"
	},
	{
		goalName: "relationship",
		goalDescription: "Deepen relationships with top customers",
		goalIcon: "./images/goals-icon-relationship.svg",
		goalIconFilled: "./images/goals-icon-filled-relationship.svg"
	},
	{
		goalName: "raise",
		goalDescription: "Raise average order value",
		goalIcon: "./images/goals-icon-raise.svg",
		goalIconFilled: "./images/goals-icon-filled-raise.svg"
	},
	{
		goalName: "boost",
		goalDescription: "Boost social media engagement",
		goalIcon: "./images/goals-icon-boost.svg",
		goalIconFilled: "./images/goals-icon-filled-boost.svg"
	},
	{
		goalName: "decrease",
		goalDescription: "Decrease time to second purchase",
		goalIcon: "./images/goals-icon-decrease.svg",
		goalIconFilled: "./images/goals-icon-filled-decrease.svg"
	},
	{
		goalName: "lower",
		goalDescription: "Lower customer acquisition cost",
		goalIcon: "./images/goals-icon-lower.svg",
		goalIconFilled: "./images/goals-icon-filled-lower.svg"
	}
];

export default goalList;
